import { Loader2 } from 'lucide-react'

import { useProject } from '@/modules/projects'
import { isProjectProcessing } from '@/modules/projects/status'

// Banner shown inside the expanded chat while the project still has
// statements processing in the background. The data table is already
// populated (we gate the sidebar on firstProcessedAt), but answers may
// reflect a partial corpus until processing completes.
export default function ProcessingNotice() {
  const project = useProject()

  if (!isProjectProcessing(project)) return null

  return (
    <output className="flex items-start gap-2 border-b border-amber-300/50 bg-amber-50 px-6 py-2 text-xs text-amber-900 dark:border-amber-400/30 dark:bg-amber-950/40 dark:text-amber-200">
      <Loader2 className="mt-0.5 h-3.5 w-3.5 shrink-0 animate-spin" />
      <p className="leading-snug">
        Statements are still processing. Chat replies may not reflect your
        complete data set yet — you may want to wait until processing finishes.
      </p>
    </output>
  )
}
